/* --- icon variant (legacy card, Marketplace/Kiosk/Boost) --- */
.toggle {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgb(255 255 255 / 95%);
  border: 1.5px solid var(--colors-grays-light);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: var(--layers-visible);
  color: var(--colors-grays-black);
  backdrop-filter: blur(4px);
  padding: 0;
}

.toggle:hover {
  border-color: var(--colors-primary-main);
  background: var(--colors-grays-white);
}

.toggle svg {
  width: 16px;
  height: 16px;
}

.toggle__active {
  background: var(--colors-primary-main);
  border-color: var(--colors-primary-main);
  color: var(--colors-grays-white);
}

.toggle__active:hover {
  background: var(--colors-primary-dark);
  border-color: var(--colors-primary-dark);
}

@media (--reefer-media-tablet-max) {
  .toggle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    bottom: 8px;
    left: 8px;
  }

  .toggle svg {
    width: 14px;
    height: 14px;
  }
}

/* --- labeled pill variant (custom-components product card) --- */
.pill {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid var(--colors-transparent-black-five);
  border-radius: 999px;
  background: var(--colors-grays-white);
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.pill__large {
  font-size: 16px;
  padding: 8px 16px;
}

.pill:hover,
.pill:focus-visible {
  background: var(--colors-grays-light);
}

.pill:active {
  background: color-mix(
    in srgb,
    var(--colors-grays-light) 75%,
    var(--colors-grays-mid)
  );
}

.pill__active,
.pill__active:hover,
.pill__active:active {
  background: var(--colors-grays-white);
  box-shadow: 0 2px 8px rgb(0 0 0 / 12%);
}

.pill__disabled,
.pill__disabled:hover {
  background: var(--colors-grays-white);
  opacity: 0.5;
  cursor: not-allowed;
}

.pill .label {
  font-size: inherit;
}

.indicator {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--colors-grays-mid);
  background: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.pill__active .indicator {
  background: var(--colors-primary-main);
  border-color: var(--colors-primary-main);
}

.pill:not(.pill__active, .pill__disabled):hover .indicator,
.pill:not(.pill__active, .pill__disabled):active .indicator {
  background: var(--colors-grays-white);
}

.pill_overlay {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: var(--layers-visible);
}

.pill_inline {
  align-self: flex-start;
  margin-top: 8px;
}

@media (--reefer-media-tablet-max) {
  .pill__large {
    padding: 4px 8px;
  }
}
